import React from 'react';
import cn from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import VideoDuration from 'components/UI/VideoDuration';

import * as styles from './VideoCard.module.scss';

export default function VideoCard({ openModal, cover, title, description, duration, isThemeDark }) {
  const textColor = isThemeDark ? 'white' : 'black';

  return (
    <div role="button" className={cn(styles.item, isThemeDark && styles.dark)} onClick={openModal}>
      <div className={styles.pictureWrapper}>
        <GatsbyImage
          image={getImage(cover)}
          className={styles.picture}
          imgClassName={styles.img}
          alt={title}
        />
        <VideoDuration className={styles.time} duration={duration} />
      </div>
      <div className={styles.text}>
        <p className={styles.tag}>Interview</p>
        <Title className={styles.title} size="h4" color={textColor}>
          {title}
        </Title>
        <Subtitle className={styles.subtitle}>{description}</Subtitle>
      </div>
    </div>
  );
}
